const colors = {
  primary: '#0AC8FF',
  secondary: '#B496FF',
};

export default colors;
